import {APIv1} from "../../api";

export async function createSavedMarket({marketId, token}) {
    const finalToken = token || JSON.parse(localStorage.getItem('user'))?.token;

    const body = {
        market_id: marketId,
    };

    try {
        const response = await APIv1.post('/save/market/', body, {
            headers: {
                Authorization: `Token ${finalToken}`,
                'Content-Type': 'application/json',
            },
        });

        return {
            success: response.status === 200 || response.status === 201,
            message: response.data?.message || "",
        };
    } catch (error) {
        console.error("Error in createSavedMarket:", error);
        return {success: false, message: "Unknown error"};
    }
}